import { useState, useEffect, useMemo } from 'react';
import Notes from '@components/Products/FixedDeposits/components/ComparisonTable/Notes';
import FdComparisonTable from '@components/Products/FixedDeposits/components/ComparisonTable/FdComparisonTable';
import { Button } from '@ui/atoms/design-system';
import { cn } from '@ui/helpers/utils';
import { Image, Text } from '@ui/atoms';

const FDInterestRateComparison = ({ fdCompareContent }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Data for table
    const data = useMemo(() => fdCompareContent?.tableData, []);

    const visibleData = isMobile && !isExpanded ? data.slice(0, 4) : data;

    return (
        <section className="bg-fd-compare-gradient">
            <div className="py-6 px-4 max-w-[1082px] w-full mx-auto md:py-18 flex flex-col gap-4 md:gap-4 lg:px-0">
                <div className="flex flex-col gap-4">
                    <Text
                        content={fdCompareContent?.title}
                        className="text-left p2-regular md:h3-regular text-basicBlack"
                        htmlTag="h2"
                    />
                    <Text
                        content={fdCompareContent?.description}
                        className="text-left text-gray-500 p4-regular md:h5-regular"
                        htmlTag="p"
                    />
                </div>

                <FdComparisonTable
                    isMobile={isMobile}
                    data={visibleData}
                    isExpanded={isExpanded}
                    fdCompareContent={fdCompareContent?.tableData}
                />

                {/* Mobile "View All" Button */}
                {isMobile && (
                    <div className="mx-auto text-center">
                        <Button
                            buttonText={isExpanded ? 'View Less' : 'View All'}
                            onClick={() => setIsExpanded(!isExpanded)}
                            buttonType="ghost"
                            buttonSize="extrasmall"
                            prefixComponent={
                                <Image
                                    src="/images/products/CaretDown.svg"
                                    alt="arrow-down"
                                    className={cn(
                                        'w-4 h-4 transform transition-transform',
                                        {
                                            'rotate-180': isExpanded,
                                        }
                                    )}
                                />
                            }
                        />
                    </div>
                )}

                {/* Notes Section */}
                <Notes
                    note1={fdCompareContent?.note1}
                    note2={fdCompareContent?.note2}
                />
            </div>
        </section>
    );
};

export default FDInterestRateComparison;
